// If you need to dispatch actions from an effect, you can use this service
// since dispatching actions directly from effects is discouraged

import { Injectable } from '@angular/core';
import { ActionCreator, Store } from '@ngrx/store';

@Injectable({providedIn: 'root'})
export class StoreActionsDispatchService {
  constructor(private store: Store) {
  }

  public dispatch(actionCreator: ActionCreator<string, (actionPayload?: any) => any>,
                  actionPayload?: any) {
    this.store.dispatch(actionCreator(actionPayload));
  }
}